"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowDown = function ArrowDown(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M12.5625 9.125C13.4254 9.125 14.125 8.42545 14.125 7.5625C14.125 6.69956 13.4254 6 12.5625 6C11.6996 6 11 6.69956 11 7.5625C11 8.42545 11.6996 9.125 12.5625 9.125Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12.5625 14.25C13.4254 14.25 14.125 13.5504 14.125 12.6875C14.125 11.8246 13.4254 11.125 12.5625 11.125C11.6996 11.125 11 11.8246 11 12.6875C11 13.5504 11.6996 14.25 12.5625 14.25Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12.5625 19.375C13.4254 19.375 14.125 18.6754 14.125 17.8125C14.125 16.9496 13.4254 16.25 12.5625 16.25C11.6996 16.25 11 16.9496 11 17.8125C11 18.6754 11.6996 19.375 12.5625 19.375Z",
    fill: props.foregroundColor
  }));
};

ArrowDown.defaultProps = {
  altText: "Kebab Menu",
  foregroundColor: "#2D5AB4"
};
ArrowDown.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = ArrowDown;
exports.default = _default;